<ca-login-info-popup>
    <div class="link-expired-popup">
        <div class="link-expired-popup-icon"></div>
        <div class="link-expired-popup-title">{{ TEXTS.LOGIN_WINDOWS.errorLink }}</div>
    </div>
</ca-login-info-popup>
